import React, { useContext, useEffect, useState } from 'react';
import Grid from "@material-ui/core/Grid";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import { AppContext } from '../Context';
import FamilyDayPresentationsForm from './FamilyDayPresentationsForm';
import FamilyDayRegisterationEdit from './FamilyDayRegisterationEdit';
import FamilyDayEventsConfirm from './FamilyDayEventsConfirm';
import FamilyDayEventsSuccess from './FamilyDayEventsSuccess';
import { DateTime } from "luxon";
import { UserProfile } from '../../_models/common/profile.model';
import baseApi from '../../_api/base.api';
import { FamilyDayRegistrationModel } from "../../_models/invitation/FamilyDayRegistratoin.model";
import Familiedagcover from '../Familiedagcover.jpg'

// Step titles
const labels = ['Family Day Registeration', 'Presentations/Tours Registeration'];

const handleSteps = (step: number, userregistration: any) => {

  switch (step) {
    case 0:
      return <FamilyDayRegisterationEdit familyDayRegistration={userregistration} />
    case 1:
      return <FamilyDayPresentationsForm familyDayRegistration={userregistration} />
    default:
      throw new Error('Unknown step')
  }
}

export default function FamilyDayEventsStepForm() {

  const { activeStep } = useContext(AppContext);
  const [userRegistration, setuserRegistration] = useState<FamilyDayRegistrationModel>();

  useEffect(() => {

    const profile = localStorage.getItem("UserProfile");
    if (profile !== null && profile !== undefined) {

      const userProfile: UserProfile = profile !== null ? JSON.parse(profile) : {} as UserProfile;

      baseApi.Invitations.GetFamilyDayRegistration(userProfile.onPremisesSamAccountName).then(
        (response: FamilyDayRegistrationModel) => {
          if (response) {
            setuserRegistration(response);
          }
        });
    }

  }, []);

  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <>
            {activeStep === labels.length ? (
              <FamilyDayEventsSuccess />
            ) : (
              <>
                {/* <div style={{ margin: "30px 0 50px" }}>
                  <Typography variant="h4" align="center">
                    Family Day Registration {DateTime.now().year}
                  </Typography>

                </div> */}
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <img src={Familiedagcover} alt="" style={{ maxWidth: "100%", height: "auto" }}  ></img>
                  </Grid>
                </Grid>
                <Stepper
                  activeStep={activeStep}
                  style={{ margin: "30px 0 15px" }}
                  alternativeLabel
                >
                  {labels.map((label) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>

                {handleSteps(activeStep, userRegistration)}
              </>
            )}
          </>
        </div>
      </section>
    </div>
  );
}
